// EditTermsAndConditions.jsx
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = 'https://api.sofiasurgicals.com/api';

const joditConfig = {
    readonly: false,
    height: 450,
    placeholder: 'Write Terms & Conditions content here...',
    buttons: [
        'bold', 'italic', 'underline', '|',
        'ul', 'ol', '|',
        'h1', 'h2', 'h3', '|',
        'blockquote', 'link', '|',
        'undo', 'redo',
    ],
};

const EditTermsAndConditions = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const editorRef = useRef(null);

    const [content, setContent] = useState('');
    const [status, setStatus] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    // ── Fetch existing ──────────────────────────────────────────
    useEffect(() => {
        const fetchData = async () => {
            try {
                // ✅ FIX: correct endpoint + correct field name
                const res = await axios.get(`${BASE_URL}/get-TermsAndCondition-by-id/${id}`);
                setContent(res.data.TermsAndCondition || ''); // ✅ TermsAndCondition not policy
                setStatus(!!res.data.status);
            } catch (err) {
                console.error(err);
                toast.error('Failed to fetch Terms & Conditions');
            } finally {
                setIsFetching(false);
            }
        };
        fetchData();
    }, [id]);

    // ── Submit ──────────────────────────────────────────────────
    const handleSubmit = async (e) => {
        e.preventDefault();

        const currentContent = editorRef.current?.value || content;
        if (!currentContent || currentContent.replace(/<[^>]+>/g, '').trim().length < 10) {
            toast.error('Terms & Conditions content is required');
            return;
        }

        setIsLoading(true);
        try {
            // ✅ FIX: correct endpoint + correct field name
            await axios.put(`${BASE_URL}/update-TermsAndCondition/${id}`, {
                TermsAndCondition: currentContent,
                status,
            });
            toast.success('Terms & Conditions updated successfully!');
            setTimeout(() => navigate('/all-TermsAndCondition'), 1500);
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to update Terms & Conditions');
        } finally {
            setIsLoading(false);
        }
    };

    // ── Loading ─────────────────────────────────────────────────
    if (isFetching) {
        return (
            <div className="d-flex justify-content-center align-items-center mt-5">
                <div className="spinner-border text-primary me-2" role="status" />
                <span>Loading Terms &amp; Conditions...</span>
            </div>
        );
    }

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="bread d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0">Edit Terms &amp; Conditions</h4>
            </div>

            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-12">
                    <label className="form-label fw-semibold">
                        Content <span className="text-danger">*</span>
                    </label>
                    <JoditEditor
                        ref={editorRef}
                        value={content}
                        config={joditConfig}
                        onBlur={(val) => setContent(val)} // ✅ onBlur not onChange
                    />
                </div>

                <div className="col-md-12">
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="statusCheck"
                            checked={status}
                            onChange={(e) => setStatus(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="statusCheck">
                            Active (visible on website)
                        </label>
                    </div>
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className="btn btn-primary px-5"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Saving...
                            </>
                        ) : (
                            'Update Terms & Conditions'
                        )}
                    </button>
                </div>
            </form>
        </>
    );
};

export default EditTermsAndConditions;